export const formateTagList = (list, selectedTags, reverseTags) => {
  const allTagList = []
  list.forEach(v => {
    v.searchTag = true
    v.key = v.type == 'defaultTag' ? '' : `${v.type}_${v.name}`
    if (selectedTags.includes(v.key || v.name)) {
      v.selected = true
    } else {
      v.selected = false
    }
    if (reverseTags.includes(v.key || v.name)) {
      v.reversed = true
    } else {
      v.reversed = false
    }
    allTagList.push(v)
  })
  // 不添加排序逻辑了
  // allTagList.sort((x, y) => {
  //   // 获取x和y在a中的索引
  //   let xi = selectedTags.indexOf(x.name)
  //   let yi = selectedTags.indexOf(y.name)

  //   // 如果都在a中，按照在a中的顺序排序
  //   if (xi !== -1 && yi !== -1) {
  //     return xi - yi
  //   }

  //   // x在a中，y不在，x排在前面
  //   if (xi !== -1) {
  //     return -1
  //   }

  //   // y在a中，x不在，y排在前面
  //   if (yi !== -1) {
  //     return 1
  //   }

  //   // 如果都不在a中，按照name的字母顺序排序
  //   if (x.name.toLowerCase() < y.name.toLowerCase()) {
  //     return -1
  //   }
  //   if (x.name.toLowerCase() > y.name.toLowerCase()) {
  //     return 1
  //   }

  //   // 如果name相同，则不改变顺序
  //   return 0
  // })
  return allTagList
}

// 解析多 tag 筛选生效匹配模式（MH-3459，2.0 简化口径）：
// 组设置 tagFilterMode 为 'any' 时发并集 'any'；'all'/'expose'/缺值/未知值一律收敛为交集 'all'（等同后端缺省，行为不变）[Claude Code]
export const resolveTagMatchMode = (tagFilterMode) => {
  return tagFilterMode == 'any' ? 'any' : 'all'
}

// MH-3512: 用最新 tagList 校验已选的自定义 tag key，剔除已被删除的「幽灵 key」，返回 { keys, removed }。
// 幽灵 key 的来源：tag 从对象上摘掉后不再出现在 tagList 中，但它仍留在宿主 params 里、还被 setUserBehavior 持久化，
// 于是列表查询照旧带着它发出去，结果停在删除前的旧过滤结果（MH-3512）。
// 边界口径：
// - 只校验自定义 tag。source/dest 类型枚举（defaultTag 贡献，落在 includeTypeList/excludeTypeList）不会被删除，不参与校验
// - 存在集同时收 `${type}_${name}` 与裸 name 两种形态：前者是当前 formateTagData 产出的 key，后者兜早期 behavior 里的历史数据，宁松不紧
// - tagList 为空（还没取到 / 接口失败）时原样返回、removed 为空：宁可不剔除，也不能把用户已选的筛选条件清空 [Claude Code]
export const filterExistTagKeys = (selectedKeys, tagList) => {
  const keys = Array.isArray(selectedKeys) ? selectedKeys : []
  if (!keys.length) return { keys, removed: [] }
  if (!Array.isArray(tagList) || !tagList.length) return { keys, removed: [] }
  const existKeys = new Set()
  tagList.forEach(v => {
    if (!v || v.type == 'defaultTag') return
    if (v.name) {
      existKeys.add(v.name)
      existKeys.add(`${v.type}_${v.name}`)
    }
  })
  const remain = []
  const removed = []
  keys.forEach(k => {
    existKeys.has(k) ? remain.push(k) : removed.push(k)
  })
  return { keys: remain, removed }
}

export const selectTagsFn = (list, index, flag) => {
  const item = list[index]
  if (item.reversed) { // 如果反选状态，取消反选
    item.reversed = false
  } else {
    if (item.selected) { // 如果选中，再次点击则为反选
      flag && (item.reversed = true)
      item.selected = false
    } else {
      item.selected = true
    }
  }
  // if (item.selected) {
  // item.selected = false

  // 取消选择得元素依次排在选中得后面，该逻辑暂时不要
  // list.splice(index, 1)
  // let btn = false
  // list.forEach((v, i) => {
  //   if (!btn && !v.selected) {
  //     btn = true
  //     list.splice(i, 0, item)
  //   }
  // })
  // if (!btn) { // 全选了
  //   list.push(item)
  // }
  // } else {
  // item.selected = true
  // 选中得元素排在最前面，该逻辑暂时不要
  // list.splice(index, 1)
  // list.unshift(item)
  // }
  return list
}

export default {
  formateTagList,
  selectTagsFn,
  resolveTagMatchMode,
  filterExistTagKeys
}
